import { render, staticRenderFns } from "./vmCurrentGreeting.vue?vue&type=template&id=6365549e&scoped=true&"
import script from "./vmCurrentGreeting.vue?vue&type=script&lang=js&"
export * from "./vmCurrentGreeting.vue?vue&type=script&lang=js&"
import style0 from "./vmCurrentGreeting.vue?vue&type=style&index=0&id=6365549e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365549e",
  null
  
)

export default component.exports